import { useState, Fragment } from 'react'
import { useDropzone } from 'react-dropzone'
import PropTypes from 'prop-types'
import bytes from 'bytes'

import './UploadDropZone.scss'

const UploadDropZone = ({
  accept,
  acceptText,
  dropText = "Déposer mon fichier en Drag'n'Drop",
  uploadText = "Sélectionner mon fichier",
  uploadModifyText = "Modifier mon fichier",
  uploadDeleteText = "Supprimer mon fichier",
  className = "",
  deletable = false,
  onSubmit,
  deleteFile = () => {},
  input,
  hideText,
  maxSize,
  extraActions,
  children
}) => {
  const [rejected, setRejected] = useState(null)

  const handleSubmit = (selectedFile) => {
    const formData = new FormData()
    const name = input.name || 'file'
    formData.append(name, selectedFile, selectedFile.name)
    const onChange = input.onChange || (() => {})

    onSubmit(formData)
      .then((result) => {
        onChange(result)
      })
      .catch(() => {
        onChange(null)
      })
  }

  const onDrop = (acceptedFiles, fileRejections) => {
    if (acceptedFiles.length) {
      setRejected(null)
      handleSubmit(acceptedFiles[0])
    } else if (fileRejections.length) {
      setRejected(fileRejections[0].file.name)
    }
  }

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
    isDragAccept
  } = useDropzone({
    accept,
    multiple: false,
    disabled: false,
    maxSize,
    onDrop
  })

  return (
    <div {...getRootProps({ className: `upload-dropzone ${className} ${isDragActive ? 'active' : ''} ${isDragAccept ? 'accept' : ''} ${isDragReject ? 'reject' : ''}` })}>
      <input {...getInputProps()} />
      <div className="content">
        {!hideText ? (
          <Fragment>
            <span className="main">{dropText}</span>
            <br />
            {rejected && (
              <div className="callout callout-danger">
                Le fichier "<b>{rejected}</b>" est invalide
              </div>
            )}
            <span className="rules">
              Fichiers autorisés ({acceptText})
              {maxSize ? `, taille maximum ${bytes(maxSize)}` : ''}
            </span>
            <br />
            ou
            <div className="d-flex justify-content-center align-items-center">
              <button type="button" className="btn btn-primary mx-1">
                {!input.value ? uploadText : uploadModifyText}
              </button>
              {input.value && deletable && (
                <button
                  onClick={deleteFile}
                  type="button"
                  className="btn btn-danger mx-1"
                >
                  {uploadDeleteText}
                </button>
              )}
              {extraActions && (
                <div onClick={(e) => e.stopPropagation()}>
                  {extraActions}
                </div>
              )}
            </div>
          </Fragment>
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            <button type="button" className="btn btn-primary mx-0">
              {!input.value ? uploadText : uploadModifyText}
            </button>
            {input.value && deletable && (
              <button
                onClick={deleteFile}
                type="button"
                className="btn btn-danger mx-1"
              >
                {uploadDeleteText}
              </button>
            )}
            {extraActions && (
              <div onClick={(e) => e.stopPropagation()}>
                {extraActions}
              </div>
            )}
          </div>
        )}
      </div>
      {children}
    </div>
  )
}

UploadDropZone.propTypes = {
  accept: PropTypes.object,
  acceptText: PropTypes.string.isRequired,
  dropText: PropTypes.string,
  uploadText: PropTypes.string,
  uploadModifyText: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  input: PropTypes.object.isRequired,
  deletable: PropTypes.bool,
  uploadDeleteText: PropTypes.string,
  deleteFile: PropTypes.func,
  className: PropTypes.string,
  hideText: PropTypes.bool,
  maxSize: PropTypes.number,
  extraActions: PropTypes.node,
  children: PropTypes.node
}

export default UploadDropZone